import Vue from "vue"
import XEUtils from "xe-utils"
import VXETablePluginElement from "vxe-table-plugin-element"
import "vxe-table-plugin-element/dist/style.css"
import {
  // 核心
  VXETable,

  // 功能模块
  // Icon,
  // Filter,
  // Menu,
  Edit,
  // Export,
  // Keyboard,
  // Validator,
  Header,
  // Footer,

  // 可选组件
  Column,
  Colgroup,
  // Grid,
  // Toolbar,
  // Pager,
  // Checkbox,
  // CheckboxGroup,
  // Radio,
  // RadioGroup,
  // RadioButton,
  // Input,
  // Textarea,
  // Button,
  // Modal,
  Tooltip,
  // Form,
  // FormItem,
  // FormGather,
  // Select,
  // Optgroup,
  // Option,
  // Switch,
  // List,
  // Pulldown,

  // 表格
  Table
} from "vxe-table"
import zhCN from "vxe-table/lib/locale/lang/zh-CN"

// 按需加载的方式默认是不带国际化的，自定义国际化需要自行解析占位符 '{0}'，例如：
VXETable.setup({
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args),
  icon: {
    TABLE_TREE_LOADED: "el-icon-loading",
    TABLE_TREE_OPEN: "el-icon-arrow-right rotate90",
    TABLE_TREE_CLOSE: "el-icon-arrow-right"
  }
})
VXETable.use(VXETablePluginElement)

// 表格功能
Vue.use(Header)
  // .use(Footer)
  // .use(Icon)
  // .use(Filter)
  .use(Edit)
  // .use(Menu)
  // .use(Export)
  // .use(Keyboard)
  // .use(Validator)

  // 可选组件
  .use(Column)
  .use(Colgroup)
  // .use(Grid)
  // .use(Toolbar)
  // .use(Pager)
  // .use(Checkbox)
  // .use(CheckboxGroup)
  // .use(Radio)
  // .use(RadioGroup)
  // .use(RadioButton)
  // .use(Input)
  // .use(Textarea)
  // .use(Button)
  // .use(Modal)
  .use(Tooltip)
  // .use(Form)
  // .use(FormItem)
  // .use(FormGather)
  // .use(Select)
  // .use(Optgroup)
  // .use(Option)
  // .use(Switch)
  // .use(List)
  // .use(Pulldown)

  // 安装表格
  .use(Table)
